import { FormItemProps, Select, SelectProps } from 'antd';
import { observer } from 'mobx-react-lite';
import { FormItem } from 'src/components/Form/FormItem';
import styled from 'styled-components';

export type SelectFieldProps = FormItemProps<string> & {
    selectProps?: Omit<SelectProps, 'label'>;
    mode?: SelectProps['mode'];
    options: SelectProps['options'];
    isLoading?: boolean;
};

export const SelectField = observer(
    ({
        name,
        label,
        selectProps,
        mode,
        options,
        isLoading,
        ...props
    }: SelectFieldProps) => {
        return (
            <FormItem {...props} name={name} label={label}>
                {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                {/* @ts-ignore */}
                <StyledSelect
                    mode={mode}
                    options={options}
                    loading={isLoading}
                    {...selectProps}
                />
            </FormItem>
        );
    },
);

const StyledSelect = styled(Select)<{ props?: SelectProps }>`
    .ant-select-selector {
        height: 40px !important;
        padding: 8px 12px !important;
        border-radius: 6px !important;
    }

    .ant-select-selection-item {
        line-height: 22px !important;
    }
`;
